"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeService = void 0;
const core_1 = require("@apollo/client/core");
const common_1 = require("../common");
const classes_1 = require("./classes");
const assets_1 = require("../assets");
class ExchangeService extends common_1.Service {
    async getExchangeSupportedAssets(page = null, limit = null) {
        const { apiService, accountService } = this.services;
        const account = accountService.accountAddress;
        const { result } = await apiService.query(core_1.gql `
        query($chainId: Int, $account: String!, $page: Int, $limit: Int) {
          result: exchangeSupportedAssets(chainId: $chainId, account: $account, page: $page, limit: $limit) {
            items {
              address
              name
              symbol
              decimals
              logoURI
            }
            currentPage
            nextPage
          }
        }
      `, {
            variables: {
                account,
                page: page || 1,
                limit: limit || 100,
            },
            models: {
                result: assets_1.PaginatedTokens,
            },
        });
        return result;
    }
    async getExchangeOffers(fromTokenAddress, toTokenAddress, fromAmount) {
        const { apiService, accountService } = this.services;
        const account = accountService.accountAddress;
        const { result } = await apiService.query(core_1.gql `
        query(
          $chainId: Int
          $account: String!
          $fromTokenAddress: String!
          $toTokenAddress: String!
          $fromAmount: BigNumber!
        ) {
          result: exchangeOffers(
            chainId: $chainId
            account: $account
            fromTokenAddress: $fromTokenAddress
            toTokenAddress: $toTokenAddress
            fromAmount: $fromAmount
          ) {
            items {
              provider
              receiveAmount
              exchangeRate
              transactions {
                to
                data
                value
              }
            }
          }
        }
      `, {
            variables: {
                account,
                fromTokenAddress,
                toTokenAddress,
                fromAmount,
            },
            models: {
                result: classes_1.ExchangeOffers,
            },
        });
        return result ? result.items : null;
    }
}
exports.ExchangeService = ExchangeService;
